<template>
  <svg class="svg-icon" :style="svgStyle" aria-hidden="true">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'currentColor'
  },
  size: {
    type: [Number, String],
    default: 16
  }
})

const symbolId = computed(() => `#icon-${props.name}`)
const svgStyle = computed(() => {
  return {
    fill: props.color,
    width: `${props.size}px`,
    height: `${props.size}px`
  }
})
// const className = computed(() => 'svg-icon')
</script>

<style scoped>
.svg-icon {
  vertical-align: middle;
  overflow: hidden;
}
</style>